import React from 'react';
import PropTypes from 'prop-types';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import { UncontrolledTable } from '~/components';
import usePatient from '~/utils/patient/hook';
import { MatchStatus } from '~/utils/const/identity';

const OpenReferrals = ({ allData }) => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="open-referrals"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-referral',
        params: {
          sacwis_id: sacwisId,
          match_status_id: MatchStatus.Approved,
          'all-data': allData ? '1' : null,
          rank: '1',
        },
      }}
      defaultSorted={[{ id: 'referralentrydateDt', desc: true }]}
      columns={[{
        id: 'referralentrydateDt__>>',
        Header: 'Date',
        accessor: 'attributes.referralentrydateDt',
        cellType: 'date',
        Filter: d => <TableFilterDateRange {...d} />,
      }, {
        id: 'referrer',
        Header: 'Referred By',
        accessor: 'attributes.referrer',
      }, {
        id: 'sourceDescription',
        Header: 'Reporting Healthcare Institution',
        accessor: 'attributes.sourceDescription',
        Filter: d => <TableFilterIdentitySource {...d} />,
      }, {
        id: 'referralSpecialty',
        Header: 'Referred To',
        accessor: 'attributes.referralspecialty',
      }]}
    />
  );
};

OpenReferrals.propTypes = {
  allData: PropTypes.bool,
};

OpenReferrals.defaultProps = {
  allData: false,
};

export default OpenReferrals;
